import React, { ReactElement } from 'react';
import useStyles from './styles';
import { Control, DeepMap, FieldError, useForm } from 'react-hook-form';
import TranslatedText from '../../../../../../components/atoms/translated_text';
import { Translations, getSupplyTypes } from './configuration';
import {
  AppSelect,
  AppTextField,
} from '../../../../../../components/molecules/form_controls';
import GridLayout from '../../../../../../components/molecules/grid_layout';
import { getState } from '../../../../../../redux/store';
import { ReducerKeys } from '../../../../../../redux/reducers';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import * as CurrencyUtils from '../../../../../../utils/currency';
import { SupplyTypes } from 'config';
import VatReturnDetailsActions from '../../../../../../redux/reducers/vatReturn_detail_reducer/actions';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import * as VatReturnUtils from '../../../../utils';
import { StateStatus } from 'redux/utils/common';
import { SchemeTypes } from 'config';
import * as VatReturnDetailSelectors from '../../../../../../redux/reducers/vatReturn_detail_reducer/selectors';

interface IProps {
  vat_number: string;
  ossScheme: number;
}

interface FormFields {
  vatNum: string | null;
  typeOfSupply: string | null;
  consumerCountry: string | null;
  vatRateType: string | null;
  taxableAmount: number | null;
  cents: number | null;
}

interface ISuppliesFromMemberStateOfIdentification {
  vat_return_supply_id: number;
  supply_type: string;
  supply_type_id: number;
  consumer_id: number;
  consumer: string;
  vat_rate_id: number;
  vat_rate: number;
  vat_rate_type: string;
  taxable_amount: number;
  vat_amount: number;
}

export default function AddSupplyFromMemberStateOfIdentificationForm(
  props: IProps
): ReactElement {
  // console.log('Render AddSupplyForm');
  const dispatch = useDispatch();
  const defaultValues = {
    vatNum: props.vat_number,
    typeOfSupply: null,
    consumerCountry: null,
    vatRateType: null,
    taxableAmount: null,
    cents: null,
  };

  const vatReturnDetail = VatReturnDetailSelectors.useGetVatReturnDetail();
  console.log('>>>>vatReturnDetail1', vatReturnDetail);
  console.log(
    '>>>vatReturnDetail.data.nonUnionSchemeDetail.notEstablished',
    vatReturnDetail.data.nonUnionSchemeDetail.notEstablished
  );
  const { errors, control, handleSubmit, watch, setError, setValue } =
    useForm<FormFields>({
      defaultValues,
    });
  const classes = useStyles();
  const watchConsumer = watch('consumerCountry');

  React.useEffect(() => {
    setValue('vatRateType', null);
  }, [watchConsumer]);

  const onSubmit = (data: any) => {
    let newData: Array<ISuppliesFromMemberStateOfIdentification> =
      new Array<ISuppliesFromMemberStateOfIdentification>();
    let reduxData: Array<ISuppliesFromMemberStateOfIdentification> = getState(
      ReducerKeys.VATRETURN_DETAIL_REDUCER
    ).vatReturnDetail.suppliesFromMemberStateOfIdentification.items;
    let countries = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER).countries;

    let taxable_amount =
      Number.parseInt(data.taxableAmount) + Number.parseInt(data.cents) / 100;
    if (taxable_amount <= 0) {
      setError('taxableAmount', {
        message: 'Taxable amount should be greater than 0!',
        shouldFocus: true,
      });
      return;
    }

    if (
      Number.parseInt(data.typeOfSupply) === SupplyTypes.SERVICES &&
      (props.ossScheme === SchemeTypes.EU ||
        props.ossScheme === SchemeTypes.NON_EU) &&
      countries.data[data.consumerCountry - 1].country ===
        'United Kingdom (Northern Ireland)'
    ) {
      setError('typeOfSupply', {
        message:
          'Supplies for SERVICES are not available for Northern Ireland!',
        shouldFocus: true,
      });
      return;
    }

    for (let item of reduxData) {
      let country_rates = countries.data[data.consumerCountry - 1].vat_rate;
      if (
        item.consumer_id ===
          countries.data[data.consumerCountry - 1].country_id &&
        item.supply_type_id === Number.parseInt(data.typeOfSupply) &&
        country_rates[data.vatRateType - 1].vat_rate_id === item.vat_rate_id
      ) {
        let supply_type =
          Number.parseInt(data.typeOfSupply) === SupplyTypes.GOODS
            ? 'goods'
            : 'services';
        setError('consumerCountry', {
          type: 'manual',
          message: `You already have a supply of type ${supply_type} to the selected country`,
        });
        return;
      }
      newData.push(item);
    }

    let vat_rate =
      countries.data[data.consumerCountry - 1].vat_rate[data.vatRateType - 1]
        .vat_rate;
    let object = {
      vat_return_supply_id: 0,
      supply_type:
        Number.parseInt(data.typeOfSupply) === SupplyTypes.GOODS
          ? 'GOODS'
          : 'SERVICES',
      supply_type_id: Number.parseInt(data.typeOfSupply),
      consumer_id: countries.data[data.consumerCountry - 1].country_id,
      consumer: countries.data[data.consumerCountry - 1].country,
      vat_rate_id:
        countries.data[data.consumerCountry - 1].vat_rate[data.vatRateType - 1]
          .vat_rate_id,
      vat_rate: vat_rate,
      vat_rate_type:
        countries.data[data.consumerCountry - 1].vat_rate[data.vatRateType - 1]
          .vat_rate_type,
      taxable_amount: taxable_amount,
      vat_amount: taxable_amount * (vat_rate / 100),
    };

    newData.push(object);

    dispatch(
      VatReturnDetailsActions.setSuppliesFromMemberStateOfIdentificationAction({
        items: newData,
        total_vat_amount_payable_goods: VatReturnUtils.calculateTotalVatAmount(
          newData,
          SupplyTypes.GOODS
        ),
        total_vat_amount_payable_services:
          VatReturnUtils.calculateTotalVatAmount(newData, SupplyTypes.SERVICES),
      })
    );

    msconChanges(object, 0);

    dispatch(
      ModalActions.closeModalAction({
        modalID: ModalIDs.MODAL_ADD_SUPPLY_FROM_MEMBER_STATE_OF_IDENTIFICATION,
      })
    );
  };

  const msconChanges = (supply: any, isFixedEst: 1 | 0) => {
    let found = false;
    let reduxData = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER)
      .vatReturnDetail.mscon;
    let newMsconData = [];
    for (let item of reduxData) {
      if (item.country_id !== supply.consumer_id) newMsconData.push(item);
      else {
        found = true;
        let total_msid_goods = item.total_msid_goods;
        let total_msid_services = item.total_msid_services;
        let total_msest_goods = item.total_msest_goods;
        let total_msest_services = item.total_msest_services;
        if (isFixedEst === 1) {
          if (supply.type === 'GOODS')
            total_msest_goods += supply.taxable_amount;
          else total_msest_services += supply.taxable_amount;
        } else {
          if (supply.type === 'GOODS')
            total_msid_goods += supply.taxable_amount;
          else total_msid_services += supply.taxable_amount;
        }
        let grand_total =
          total_msid_goods +
          total_msid_services +
          total_msest_goods +
          total_msest_services;
        let due_balance = item.due_balance + supply.vat_amount;

        let obj = {
          ...item,
          total_msid_goods,
          total_msid_services,
          total_msest_goods,
          total_msest_services,
          grand_total,
          due_balance,
          total_amount_due: due_balance + item.total_correction,
        };
        newMsconData.push(obj);
      }
    }

    if (!found) {
      let total_msid_goods = 0;
      let total_msid_services = 0;
      let total_msest_goods = 0;
      let total_msest_services = 0;
      if (isFixedEst === 1) {
        if (supply.type === 'GOODS') total_msest_goods += supply.taxable_amount;
        else total_msest_services += supply.taxable_amount;
      } else {
        if (supply.type === 'GOODS') total_msid_goods += supply.taxable_amount;
        else total_msid_services += supply.taxable_amount;
      }
      let grand_total =
        total_msid_goods +
        total_msid_services +
        total_msest_goods +
        total_msest_services;
      let due_balance = supply.vat_amount;
      let obj = {
        vat_return_version_id: 0,
        country_id: supply.consumer_id,
        country: supply.consumer,
        grand_total,
        total_msid_goods,
        total_msid_services,
        total_msest_goods,
        total_msest_services,
        due_balance,
        total_correction: 0,
        total_amount_due: due_balance,
      };
      newMsconData.push(obj);
    }

    dispatch(VatReturnDetailsActions.setMsconAction(newMsconData));
  };

  return (
    <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
      <GridLayout
        elements={[
          {
            element: renderVatNumberField(errors, control),
            size: 12,
            id: 'vatNum',
          },
          {
            element: renderTypeOfSupplyField(
              errors,
              control,
              props.ossScheme,
              vatReturnDetail.data.nonUnionSchemeDetail?.notEstablished
                ? vatReturnDetail.data.nonUnionSchemeDetail.notEstablished
                : false
            ),
            size: 12,
            id: 'typeOfSupply',
          },
          {
            element: renderConsumerCountryField(errors, control),
            size: 12,
            id: 'consumerCountry',
          },
          {
            element: renderVatRateTypeField(errors, control, watchConsumer),
            size: 12,
            id: 'vatRateType',
          },
          {
            element: renderTaxableAmountField(errors, control),
            size: 10,
            id: 'taxableAmount',
          },
          {
            element: renderCentsField(errors, control),
            size: 2,
            id: 'cents',
          },
          {
            element: (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ width: '100%' }}
              >
                <TranslatedText textMap={Translations.add_supply} />
              </Button>
            ),
            size: 12,
            id: 'action',
          },
        ]}
      />
    </form>
  );
}

const renderVatNumberField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="vatNum"
      label={<TranslatedText textMap={Translations.vat_number_control} />}
      error={'vatNum' in errors}
      name="vatNum"
      control={control}
      disabled={true}
      rules={{ required: 'Required Field' }}
      helperText={errors.vatNum && errors.vatNum.message}
    />
  );
};

const renderTypeOfSupplyField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  ossScheme: number,
  notEstablished: boolean
) => {
  console.log('>>>notEstablished', notEstablished);
  let select_types = [];
  select_types.push({
    id: null,
    label: Translations.type_of_supply_control.English,
  });
  for (let type of getSupplyTypes(ossScheme, notEstablished))
    select_types.push(type);
  return (
    <AppSelect
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="typeOfSupply"
      label={<TranslatedText textMap={Translations.type_of_supply_control} />}
      error={'typeOfSupply' in errors}
      name="typeOfSupply"
      control={control}
      rules={{ required: 'Required Field' }}
      options={select_types as any}
      helperText={errors.typeOfSupply && errors.typeOfSupply.message}
    />
  );
};

const renderConsumerCountryField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const countries = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER).countries;
  let countries_list = [];
  countries_list.push({
    id: null,
    label: Translations.consumer_country_control.English,
  });
  if (countries.status === StateStatus.Success && countries.data) {
    countries.data.forEach((value: any, index: number) => {
      countries_list.push({
        id: index + 1,
        label: value.country,
      });
    });
  }
  return (
    <AppSelect
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="consumerCountry"
      label={<TranslatedText textMap={Translations.consumer_country_control} />}
      error={'consumerCountry' in errors}
      name="consumerCountry"
      control={control}
      rules={{ required: 'Required Field' }}
      options={countries_list as any}
      helperText={errors.consumerCountry && errors.consumerCountry.message}
    />
  );
};

const renderVatRateTypeField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  watchConsumer: string | null
) => {
  let rate_list = [];
  const countries = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER).countries;
  if (
    countries.status === StateStatus.Success &&
    countries.data &&
    watchConsumer
  ) {
    let country_rates =
      countries.data[Number.parseInt(watchConsumer) - 1].vat_rate;
    rate_list.push({
      id: null,
      label: Translations.vat_rate_type_control.English,
    });
    if (country_rates) {
      country_rates.forEach((value: any, index: number) => {
        rate_list.push({
          id: index + 1,
          label: `${value.vat_rate_type} (${CurrencyUtils.formatCurrency(
            value.vat_rate
          )}%)`,
        });
      });
    }
  }

  return (
    <AppSelect
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="vatRateType"
      label={<TranslatedText textMap={Translations.vat_rate_type_control} />}
      error={'vatRateType' in errors}
      name="vatRateType"
      control={control}
      rules={{ required: 'Required Field' }}
      options={rate_list as any}
      helperText={errors.vatRateType && errors.vatRateType.message}
    />
  );
};

const renderTaxableAmountField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      type={'number'}
      required
      fullWidth
      id="taxableAmount"
      label={<TranslatedText textMap={Translations.taxable_amount_control} />}
      error={'taxableAmount' in errors}
      name="taxableAmount"
      control={control}
      rules={{
        required: 'Required Field',
      }}
      helperText={errors.taxableAmount && errors.taxableAmount.message}
    />
  );
};

const renderCentsField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      type="number"
      id="cents"
      label={<TranslatedText textMap={Translations.cents_control} />}
      error={'cents' in errors}
      name="cents"
      control={control}
      rules={{
        required: 'Required',
        min: {
          value: 0,
          message: Translations.invalid_cents_error.English,
        },
        maxLength: {
          value: 2,
          message: Translations.invalid_cents_error.English,
        },
      }}
      helperText={errors.cents && errors.cents.message}
    />
  );
};
